<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption sbd" v-if="options_loaded && passed_filter" :data-designer-component-id="component_id">
            <h3>Would you like to upgrade to Secured by Design Specification?</h3>

            <h4>What's included in the upgrade?</h4>
            <div class="whatsincluded">
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-laminatedglass.jpg'" alt="" /><br />
                    Laminated <br> Glass
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-securitychain.jpg'" alt="" /><br />
                    Security <br> Chain
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-spyhole.jpg'" alt="" /><br />
                    Spyhole
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-letterplatecowl.jpg'" alt="" /><br />
                    Letterplate <br> Cowl
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-antisnapcylinder.jpg'" alt="" /><br />
                    Anti-Manipulation <br> Cylinder
                </div>
                <p>Additional items include: Steel Plate cut through panel and a Part M Compliant threshold</p>
            </div>

            <div class="whatissbd">
                <div class="txt">
                    <h4>What is Secure by Design?</h4>
                    <p>Secured By Design is a National Scheme which focuses on the security of homes. Doors manufactured to this specification support the principles of 'designing out crime' through physical security'.</p>
                </div>
                <div class="img">
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/6/sbd-upgrade.jpg'" alt="" />
                </div>
            </div>
                <div class="radiooption stylesoption mb-3">
                    <span>Would you like to upgrade to SBD?</span>
                    <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                               :name="'radio_' + component_id"
                                                                               :value="option.value"/> {{ option.label }}</label></span>
                </div>

        </div>
    </div>


</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";
    import RadioQuestion from "../mixin/britdoors/RadioQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign,
            RadioQuestion
        ],
    }
</script>
